import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Logout from '../Logout/Logout';
import './Navbar.css';
import config from '../../config';
import logo from '../../Images/logo.jpg';
import { useAuth } from '../../Auth/AuthContext'
import { FaSearch } from 'react-icons/fa';
import '../../Pages/HomePage/HomePage.css';
import Notifications from '../Notifications/Notifications';

axios.defaults.baseURL = config.BASE_URL;

const Navbar = () => {

    //const [searchValueINT, setSearchValueINT] = useState("");
    const location = useLocation();
    const Navigate = useNavigate();
    const { username, userProfile, setTripIDState, setReviseBillState, setActiveModule, searchValue, setSearchValue, reviseBillState } = useAuth();
    console.log('User profile seen from navbar module:', userProfile);


    const handleSearch = async () => {

        console.log('User profile:', userProfile);
        if (userProfile === 'loadingManager' || (userProfile === 'unloadingManager' && searchValue.startsWith('B'))) {
            alert('You do not have access to this section');
            return;
        }

        if (!searchValue) {
            alert('Please enter a valid Trip ID/Bill ID');
            return;
        }


        try {
            if (searchValue.startsWith('T')) {
                const response = await axios.get(`/api/trip/${searchValue}`,
                    {
                        withCredentials: true,
                        headers: {
                            "Content-Type": "application/json",
                        }
                    }
                );
                console.log('TripData', response.data.TripData)

                setTripIDState(response.data.TripData);

                sessionStorage.setItem('actMod', 'upload');

                setActiveModule(sessionStorage.getItem('actMod'));
                Navigate(`/home/${searchValue}`);

            } else if (searchValue.startsWith('B')) {
                const bill_id = searchValue;
                const response = await axios.post("/list-to-revise-bill", { bill_id }, {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                });

                console.log('Revised Bill listing: ', response.data);

                // Set state and navigate without triggering re-fetch
                setReviseBillState(response.data);
                sessionStorage.setItem('actMod', 'revise-bill');
                sessionStorage.setItem('reviseBillSearchProcessed', 'true'); // Add this flag
                setActiveModule('revise-bill');
                Navigate(`/revise-bill?bill_id=${bill_id}`);
            } else {
                alert("Invalid input.")
            }

        } catch (error) {
            if (error?.response?.data?.message) {
                alert(error?.response?.data?.message)
                console.log('Error:', error?.response?.data?.message)
            }
            else {
                if (!reviseBillState) {
                    alert('Error fetching the trip data')
                } else {
                    alert('Error fetching the bill data')
                }
            }

        }

    }

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault(); // Prevents form submission (if inside a form)
            handleSearch();
        }
    };

    const getRouteName = () => {
        const path = location.pathname;

        if (path === '/home') {
            return 'Upload Trip Details';
        }
        if (path.startsWith('/home/') && path !== '/home') {
            return 'Upload Trip Details';
        }
        if (path === '/today-list') {
            return `Today's List`;
        }
        else if (path === '/freight') {
            return 'Freight';
        }
        else if (path === '/vehicle') {
            return 'Vehicle';
        }
        else if (path === '/vendor') {
            return 'Vendor';
        }
        else if (path === '/reports') {
            return 'Reports';
        }
        else if (path === '/generate-bill') {
            return 'Billing';
        }
        else if (path === '/transactions') {
            return 'Transactions';
        }
        else if (path === '/business') {
            return 'Business';
        }
        else if (path === '/revise-bill') {
            return 'Revise Bill';
        }
    };

    return (
        <nav className='navbar'>
            <div className="navbar-left">
                <img src={logo} alt="Logo" className="logo" />
                <span className='Username-display'> Hello, {username}</span>
            </div>

            <div className='route-name-container'>
                <div className='route-name'>
                    {getRouteName()}
                </div>
            </div>

            <div className='nav-buttons-right'>
                <div className="search-bar-container">
                    <FaSearch className="search-icon" onClick={handleSearch} />
                    <input
                        type="text"
                        value={(searchValue || "").toUpperCase()}
                        onChange={(e) => setSearchValue((e.target.value).toUpperCase())}
                        onKeyDown={handleKeyPress}
                        placeholder="Search by Trip/Bill ID"
                        className="search-bar"
                    />
                </div>
                {userProfile !== 'loadingManager' ? <Notifications /> : ""}
                <Logout />
            </div>
        </nav>
    );

};


export default Navbar;